import { css } from '@emotion/css';

import { BREAKPOINT_QUERIES } from '@lyearn/core/hooks/useScreen';

export const PAGE_WIDTH = '104.4rem';
export const WRAPPER_PX = '4rem';

export const container = css`
  padding-top: 48px;
  padding-bottom: 136px;
  max-width: calc(${PAGE_WIDTH} + ${WRAPPER_PX});
  margin: 0 auto;
`;

export const leftCol = css`
  width: 60rem;
  @media ${BREAKPOINT_QUERIES.Mobile} {
    max-width: 100%;
  }
`;
